import React, {PureComponent} from "react";
import {Icon, Menu} from "antd";
import {Link} from "react-router-dom";
import {connect} from "react-redux";
import userModel from "../../../store/reducers/user";
import {getMenuMatches, urlToList} from "../../utils";
const {SubMenu} = Menu;


// Allow menu.js config icon as string or ReactNode
//   icon: 'setting',
//   icon: 'http://demo.com/icon.png',
//   icon: <Icon type="setting" />,
const getIcon = icon => {
  if (typeof icon === "string" && icon.indexOf("http") === 0) {
    return <img src={icon} alt="icon" className="icon"/>;
  }
  if (typeof icon === "string") {
    return <Icon type={icon}/>;
  }
  return icon;
};
@connect(({user}) => ({...user}), {...userModel.actions})
export default class BaseMenu extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      roleObj: {}
    }
  }

  componentWillMount() {
    const {userInfo} = this.props;
    let roleObj = {};
    let roleArr = [];
    if (!!localStorage.getItem('currentUser')) {
      if (userInfo.roleType === 'superadmin') {
        if (userInfo.bindAccount && userInfo.bindAccount.role && JSON.parse(userInfo.bindAccount.role).perm) {
          roleArr = JSON.parse(userInfo.bindAccount.role).perm.resources;
        } else {
          window.location.href = '/#/user/login';
        }
      } else {
        if (userInfo.role && JSON.parse(userInfo.role).perm) {
          roleArr = JSON.parse(userInfo.role).perm.resources;
        } else {
          window.location.href = '/#/user/login';
        }
      }
    } else {
      window.location.href = '/#/user/login';
      window.location.reload();
    }

    roleArr.forEach(item => {
      roleObj[item.code] = item;
    });
    // 报表先隐藏
    // delete roleObj.reports;
    this.setState({roleObj})
  }

  flatMenuKeys = this.getFlatMenuKeys(this.props.menuData);

  /**
   * Recursively flatten the data
   * [{path:string},{path:string}] => {path,path2}
   * @param  menus
   */
  getFlatMenuKeys(menus) {
    let keys = [];
    menus.forEach(item => {
      if (item.children) {
        keys = keys.concat(this.getFlatMenuKeys(item.children));
      }
      keys.push(item.path);
    });
    return keys;
  }

  // Get the currently selected menu
  getSelectedMenuKeys = () => {
    const {
      location: {pathname}
    } = this.props;
    return urlToList(pathname).map(itemPath =>
      getMenuMatches(this.flatMenuKeys, itemPath).pop()
    );
  };

  hasAuthority = (userAuth, authoritys) => {
    // Retirement authority, return target;
    if (!authoritys || !userAuth) {
      return true;
    }
    // 数组处理
    if (Array.isArray(authoritys)) {
      if (authoritys.indexOf(userAuth) >= 0) {
        return true;
      }
      return false;
    }

    // string 处理
    if (typeof authoritys === "string") {
      if (authoritys === userAuth) {
        return true;
      }
      return false;
    }
  };

  /**
   * 获得菜单子节点
   * @memberof SiderMenu
   */
  getNavMenuItems = (menusData, parent) => {
    if (!menusData) {
      return [];
    }
    return menusData
      .filter(item => item.name && !item.hideInMenu)
      .map(item => {
        // make dom
        const ItemDom = this.getSubMenuOrItem(item, parent);
        return ItemDom;
        // return this.checkPermissionItem(item.authority, ItemDom);
      })
      .filter(item => item);
  };

  /**
   * get SubMenu or Item
   */
  getSubMenuOrItem = item => {
    // doc: add hideChildrenInMenu
    const {userAuth} = this.props;
    if (
      item.children &&
      !item.hideChildrenInMenu &&
      item.children.some(child => child.name) &&
      this.hasAuthority(userAuth, item.authority)
    ) {
      return (
        <SubMenu
          title={
            item.icon ? (
              <span>
                {getIcon(item.icon)}
                <span>{item.name}</span>
              </span>
            ) : (
              item.name
            )
          }
          key={item.path}>
          {this.getNavMenuItems(item.children)}
        </SubMenu>
      );
    }
    return this.hasAuthority(userAuth, item.authority) ? (
      <Menu.Item key={item.path}>{this.getMenuItemPath(item)}</Menu.Item>
    ) : null;
  };

  /**
   * 判断是否是http链接.返回 Link 或 a
   * Judge whether it is http link.return a or Link
   * @memberof SiderMenu
   */
  getMenuItemPath = item => {
    const name = item.name;
    const itemPath = this.conversionPath(item.path);
    const icon = getIcon(item.icon);
    const {target} = item;
    // Is it a http link
    if (/^https?:\/\//.test(itemPath)) {
      return (
        <a href={itemPath} target={target}>
          {icon}
          <span>{name}</span>
        </a>
      );
    }
    const {location} = this.props;
    let showDom;
    if (item.type === 'a') {
      const currentRoute = window.location && window.location.hash && window.location.hash.split('/')[1];
      showDom = <a
        disabled={currentRoute === item.auth}
        href={`${window.location.origin}/#${itemPath}`}
        target="_blank">
        {icon}
        <span>{name}</span>
      </a>
    } else {
      showDom = <Link
        to={itemPath}
        target={target}
        replace={itemPath === location.pathname}
      >
        {icon}
        <span>{name}</span>
      </Link>
    }
    return showDom;
  };

  // permission to check
  //   checkPermissionItem = (authority, ItemDom) => {
  //     const { Authorized } = this.props;
  //     if (Authorized && Authorized.check) {
  //       const { check } = Authorized;
  //       return check(authority, ItemDom);
  //     }
  //     return ItemDom;
  //   };

  conversionPath = path => {
    if (path && path.indexOf("http") === 0) {
      return path;
    }
    return `/${path || ""}`.replace(/\/+/g, "/");
  };

  render() {
    const {
      openKeys,
      onOpenChange,
      menuData,
      theme,
      collapsed,
      className,
      mode
    } = this.props;
    let menuListData = [];
    const {roleObj} = this.state;
    const currentUser=localStorage.getItem('currentUser');//获取登录信息
    const userInfo= currentUser && JSON.parse(currentUser);//登录信息转json
    const hideItem=['内网门户'];//需要隐藏的菜单
    const accountType = userInfo && userInfo.accountType;//账号类型(1 直营 2 安拓)
    menuData.forEach(item => {
      if (item.auth) {
        if (!!roleObj[item.auth]) {
          menuListData.push(item)
        }
      } else {
        if(!(accountType!==1 && hideItem.includes(item.name))){
          menuListData.push(item)
        }
      }
    });
    let selectedKeys = this.getSelectedMenuKeys();
    if (!selectedKeys.length && openKeys) {
      selectedKeys = [openKeys[openKeys.length - 1]];
    }
    let props = {};
    if (openKeys) {
      props = collapsed ? {} : {openKeys};
    }
    return (
      <Menu
        key="Menu"
        className={className}
        theme={theme}
        mode={mode}
        onOpenChange={onOpenChange}
        selectedKeys={selectedKeys}
        {...props}
      >
        {this.getNavMenuItems(menuListData)}
      </Menu>
    );
  }
}
